import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators'
import Vue from 'vue'

@Module({
  namespaced: true
})
export default class Tasks extends VuexModule {
  categoriesLoaded = false
  categories: KwixeoTasks.Categories = []

  // CLEAR STORE STATE
  @Action
  clearStore (): void {
    const elements = ['Categories']
    elements.forEach(key => {
      this.context.commit('set' + key, [])
      this.context.commit('set' + key + 'Loaded', false)
    })
  }

  get defaultCategory (): KwixeoTasks.Category|undefined {
    return this.activeCategories.find(category => category.use_default)
  }

  get activeCategories (): KwixeoTasks.Categories {
    return this.categories.filter(category => category.status.active)
  }

  @Mutation
  setCategoriesLoaded (state = true): void {
    this.categoriesLoaded = state
  }

  @Mutation
  setCategories (categories: KwixeoTasks.Categories): void {
    categories.push({ id: 0, label: 'Autre', use_default: categories.find(category => category.use_default) === undefined, status: { active: true, name: '' } })
    this.categories = categories
  }

  @Mutation
  updateCategory (category: KwixeoTasks.Category): void {
    if (!this.categoriesLoaded) {
      return
    }
    const index = this.categories.findIndex(cat => cat.id === category.id)
    if (index >= 0) {
      Vue.set(this.categories, index, category)
    } else {
      this.categories.push(category)
    }
  }

  @Mutation
  removeCategory (category: KwixeoTasks.Category): void {
    if (!this.categoriesLoaded) {
      return
    }
    const index = this.categories.findIndex(cat => cat.id === category.id)
    if (index !== undefined) {
      Vue.delete(this.categories, index)
    }
  }

  @Action
  async loadCategories (force = false): Promise<void> {
    if (!this.categoriesLoaded || force) {
      const response = await Vue.prototype.$kwTasks.axios.get('/task/category?per_page=500&sort=label')
      await this.context.commit('setCategories', response.data.data)
      this.context.commit('setCategoriesLoaded')
    }
  }

  @Action
  setCategory (category: KwixeoTasks.Category): void {
    this.context.commit('updateCategory', category)
  }

  @Action
  deleteCategory (category: KwixeoTasks.Category): void {
    this.context.commit('removeCategory', category)
  }
}
